import { combineReducers } from "redux";

import userReducer from "./reducersStore/userReducer";

const rootReducer = combineReducers({
  user: userReducer,
});

export default rootReducer;
